<template>
  <div>
    <!-- <p
      class="Text-Hero"
      v-bind:style="{
        'font-size': fontSize,
        'margin-left': marginLeft,
        width: width,
        'margin-top': marginTop,
      }"
    >
      Dapatkan Kemudahan Pinjaman Di Platform Dompet Kilat
    </p>

    <img
      src="../../assets/pinjaman/Hero.webp"
      srcset="
        ../../assets/pinjaman/Hero@2x.png 2x,
        ../../assets/pinjaman/Hero@3x.png 3x
      "
      class="Hero"
    /> -->
    <v-carousel
      :show-arrows="false"
      delimiter-icon="mdi-square"
      hide-delimiters
      light
      :height="heightCarousel"
      deli
      hide-delimiter-background
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div
          class="Text-Hero"
          v-bind:style="{
            'font-size': fontSize,
            'margin-left': marginLeft,
            width: width,
            'margin-top': marginTop,
          }"
        >
          <p>Dapatkan Kemudahan Pinjaman Di Platform Dompet Kilat</p>

          <v-dialog
            transition="dialog-bottom-transition"
            v-model="note"
            max-width="550"
          >
            <v-card>
              <v-card-title class="white--text popupTitle">
                Download Aplikasi Dompetkilat
              </v-card-title>
              <v-card-text>
                <div class="text-h6 black--text px-2 mt-6">
                  Anda akan mengunduh aplikasi DompetKilat, Pastikan anda
                  <span class="red--text font-weight-bold"
                    >sudah memiliki kode akses</span
                  >
                </div>
                <div class="text-h6 px-2 mt-6">
                  Masukkan kode akses untuk melanjutkan

                  <v-text-field
                    class="mt-2"
                    v-model="noteCode"
                    label="Kode Akses"
                    color="#D3352C"
                    outlined
                    dense
                    required
                  ></v-text-field>
                  <strong
                    v-if="noteError"
                    class="text-body-1 red--text text--lighten-1"
                    >Kode Akses Salah !!</strong
                  >
                </div>
              </v-card-text>
              <v-divider class="mx-4" />
              <v-card-actions class="justify-end">
                <div class="pb-2">
                  <v-btn
                    class="white--text text-none"
                    color="#D3352C"
                    min-width="125"
                    rounded
                    @click="closeNote"
                    >Batal</v-btn
                  >
                  <v-btn
                    class="ml-4 text-none"
                    min-width="125"
                    outlined
                    color="black"
                    rounded
                    @click="toDownload"
                    >Selanjutnya</v-btn
                  >
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <img src="../../assets/pinjaman/Hero.svg" class="Hero" />
      </v-carousel-item>
    </v-carousel>

    <Description />
    <Table />
    <v-layout align-center column style="margin-top: 100px">
      <h1 style="Section-Titlea">Testimonial Peminjam</h1>
      <testimonial v-if="widthNow >= 1200" :testi="testiPeminjam" />
      <testimonial-mobile v-if="widthNow <= 1200" :testi="testiPeminjam" />
    </v-layout>
    <pertanyaan />
  </div>
</template>
<script>
import axios from "axios";
import Description from "../../components/pinjaman/Description";
import Pertanyaan from "../../components/pinjaman/Pertanyaan.vue";
import Table from "../../components/pinjaman/Table";
import Testimonial from "../../components/pinjaman/Testimonial.vue";
import TestimonialMobile from "../../components/pinjaman/TestimonialMobile.vue";
export default {
  components: {
    Description,
    Table,
    Testimonial,
    TestimonialMobile,
    Pertanyaan,
  },
  data() {
    return {
      widthNow: window.innerWidth,
      heroTextSize: `48px`,
      marginLeft: `${window.innerWidth / 8}px`,
      marginTop: `${window.innerWidth / 10}px`,
      width: `${window.innerWidth / 4}px`,
      heightCarousel: window.innerWidth / 2.25 + "px",
      fontSize: `40px`,
      note: false,
      noteError: false,
      noteCode: "",
      slides: [
        {
          title: "Mudah",
          content:
            "Proses pendanaan dan peminjaman secara online secara sederhana dan mudah dipahami",
          icon: "Mudah.png",
        },
        {
          title: "Cerdas",
          content:
            "Risiko terukur dengan menggunakan teknologi terbaru untuk menganalisis risiko",
          icon: "Cerdas.png",
        },
        {
          title: "Aman",
          content:
            "Mengantongi izin usaha resmi dan diawasi langsung oleh OJK (KEP-47/D.05/2019)",
          icon: "aman.png",
        },
        {
          title: "Keuntungan Menarik",
          content:
            "Dapatkan imbal hasil hingga 20% per tahun. Lebih tinggi dari produk investasi pada umumnya",
          icon: "keuntungan.png",
        },
        {
          title: "Dampak Sosial",
          content:
            "Membantu UMKM untuk mengembangkan usahanya dan mendorong pertumbuhan ekonomi nasional",
          icon: "sosial.png",
        },
        {
          title: "Tepercaya",
          content:
            "Menggunakan sistem pengelolaan risiko yang terintegrasi dan transparan dengan jaminan asuransi",
          icon: "terpercaya.png",
        },
      ],
      testiPeminjam: [
        {
          name: "Ario",
          job: "Petambak Udang",
          desc: `Selama saya mendapatkan bantuan pinjaman dari Dompet Kilat, saya sangat terbantu, terutama dari sisi finansial. Memang masih ada beberapa kekurangan dalam sistem Dompet Kilat dan termasuk saya juga tentunya, namun anggotanya sangat open minded dan terbuka untuk bekerja mencari solusi sehingga beberapa kendala dapat diatasi bersama. Maju terus Dompet Kilat!!`,
          img: require("../../assets/pinjaman/user/image_testi_borrower_1.png"),
        },
        {
          name: "Mugiyo",
          job: "Petani",
          desc: `Saya sangat bersyukur bisa bekerja sama dengan Dompet Kilat. Pinjaman finansial tentunya sangat membantu usaha saya, tapi yang lebih bermanfaat adalah ekosistem yang dibangun oleh Dompet Kilat. Usaha saya berkembang pesat setelah bekerja sama dengan Dompet Kilat. Terima Kasih!`,
          img: require("../../assets/pinjaman/user/image_testi_borrower_2.png"),
        },
        {
          name: "Wiyudo",
          job: "Tambak Udang",
          desc: `Selama 3 tahun bekerja sama dengan Dompet Kilat, saya sangat terbantu karena kita bisa mengajukan pinjaman tanpa agunan. Dompet Kilat juga menyediakan ekosistem pendanaan yang sangat membantu dalam penyediaan kebutuhan. Terima kasih Dompet Kilat!`,
          img: "",
        },
        {
          name: "Muhammad Chandra ",
          job: "Security",
          desc: `Program pembiayaan seragam dari Dompet Kilat sangat membantu saya agar dapat bekerja menggunakan seragam security yang telah ditentukan oleh perusahaan. Prosesnya gampang dan cepat! Terima kasih Dompet Kilat.
`,
          img: "",
        },
        {
          name: "Tabrani",
          job: "Petani",
          desc: `Dompet Kilat bekerjasama dengan beberapa pihak diantaranya PT. Bayer, Indo Buana Berkah & asuransi yang dapat mendampingi kami para petani agar mendapatkan hasil yang maksimal. Terima kasih Dompet Kilat!
`,
          img: "",
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    goToPage(str) {
      this.$router.push("/" + str);
    },
    resizeEventHandler() {
      this.widthNow = window.innerWidth;
      this.marginLeft = `${window.innerWidth / 8}px`;
      this.marginTop = `${window.innerWidth / 8}px`;
      this.width = `${window.innerWidth / 3}px`;
      this.fontSize = `${window.innerWidth / 40}px`;
      this.heightCarousel = window.innerWidth / 2.25 + "px";
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    toPlayStore() {
      window.location =
        "https://play.google.com/store/apps/details?id=com.dompetkilat&hl=in&gl=US";
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    download(url, title) {
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch((err) => this.rollbar.debug(err));
    },
    toDownload() {
      if (this.noteCode === process.env.VUE_APP_DOWNLOAD_PASSWORD) {
        this.download(
          "https://ws-dk.dompetkilat.id:3015/api/download",
          "DompetKilat_v3.0.apk"
        );
        this.noteCode = "";
        this.note = false;
        this.noteError = false;
      } else {
        this.noteError = true;
      }
    },
    closeNote() {
      this.note = false;
      this.noteCode = "";
      this.noteError = false;
    },
  },
};
</script>

<style>
h1 {
  flex-grow: 0;
  margin: 0px 101px 60px 102px;
  font-family: Sora;
  font-size: 32px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Text-Hero {
  width: 590px;
  margin: 137px 810px 0 200px;
  font-family: Sora;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
  position: absolute;
}

.Hero {
  width: 100%;
  object-fit: contain;
}
.gplay {
  width: 280px;
  height: 85px;
  flex-grow: 0;
  margin-left: -16px;
  cursor: pointer;
}
.popupTitle {
  background-color: #d3352c;
}
</style>
